import React from 'react'
import cx from 'classnames'

import styles from './Separator.module.scss'

type SeparatorProps = {
  className?: string
  maxWidth?: string
  tagName?: React.ElementType
}

export const Separator = ({ className, maxWidth, tagName }: SeparatorProps) => {
  const Element = tagName ?? 'hr'

  return (
    <Element
      className={cx(styles.separator, {
        [className ?? '']: Boolean(className),
      })}
      style={{ maxWidth }}
    />
  )
}
